export default "__VITE_ASSET__DGCeKW0n__"